<template>
  <SafetyAssistant v-if="safetyAssistant">
    <slot />
  </SafetyAssistant>
  <v-container v-else fill-height fluid grid-list-sm>
    <v-row align="center" justify="center">
      <v-col cols="8" xs="8" sm="6" md="3" lg="2" class="text-sm-center">
        <Branded v-if="brandingEnabled" />
        <v-img
          v-else
          aspect-ratio="2.5"
          :src="
            $vuetify.theme.dark
              ? require('@/assets/salus-logo.svg')
              : require('@/assets/salus-black.svg')
          "
          contain
        ></v-img>
      </v-col>
    </v-row>
    <slot />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Branded from '@/layouts/Branded.vue'
import SafetyAssistant from '@/layouts/SafetyAssistant.vue'
export default {
  name: 'MainLayout',
  components: {
    Branded,
    SafetyAssistant,
  },
  computed: {
    ...mapGetters({
      brandingEnabled: 'brandingEnabled',
      qrCode: 'qrCode',
      safetyAssistant: 'safetyAssistant',
    }),
  },
  mounted() {
    if (this.qrCode) {
      this.loadBranding(this.qrCode)
    }
  },
  methods: {
    ...mapActions({
      loadBranding: 'loadBranding',
    }),
  },
}
</script>

<style scoped>
.container.fill-height {
  align-content: start;
}
</style>
